import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "../../lib/api";
import { btnGhost, btnPrimary, inputCls } from "../../components/ui";

export const COMPLAINT_STATUS = { open: "Aberta", in_progress: "Em análise", resolved: "Resolvida", rejected: "Rejeitada" };
export const COMPLAINT_TYPE = { order: "Encomenda", delivery: "Entrega OBÔGO", topup: "Recarga", store: "Loja", product: "Produto", other: "Outro" };

export const Thread = ({ c }) => (
  <div className="flex flex-col gap-1.5">{c.messages.map((m, i) => (
    <p key={i} className={`max-w-[85%] rounded-xl px-3 py-2 text-sm ${m.from === "staff" ? "self-end bg-bo-green/10" : "bg-gray-50"}`}>
      <span className="block text-[11px] text-gray-500">{m.from === "staff" ? `Equipa BÔ · ${m.by}` : m.by} · {fmtDate(m.at)}</span>{m.text}</p>))}</div>
);

function Row({ c, reload }) {
  const [msg, setMsg] = useState("");
  const [open, setOpen] = useState(c.status === "open");
  const respond = async (status) => {
    try { await api.post(`/admin/complaints/${c.id}/respond`, { message: msg, status }); toast.success("Resposta enviada"); setMsg(""); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  const closed = ["resolved", "rejected"].includes(c.status);
  return (
    <div className="flex flex-col gap-2 p-4" data-testid={`admin-complaint-${c.number}`}>
      <button onClick={() => setOpen(!open)} className="flex flex-wrap items-center gap-2 text-left text-sm"><strong>{c.number}</strong><span>{c.title}</span>
        <span className="text-gray-500">· {COMPLAINT_TYPE[c.subject_type]} {c.reference} · {c.customer_name} · {fmtDate(c.created_at)}</span>
        <span className="ml-auto rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-semibold" data-testid={`admin-complaint-status-${c.number}`}>{COMPLAINT_STATUS[c.status]}</span></button>
      {open && <><Thread c={c} />
        {!closed && <div className="flex flex-wrap gap-2"><textarea rows={2} value={msg} onChange={(e) => setMsg(e.target.value)} placeholder="Resposta ao cliente" className={`${inputCls} flex-1`} data-testid={`admin-complaint-msg-${c.number}`} />
          <div className="flex flex-col gap-1">
            <button disabled={msg.trim().length < 2} onClick={() => respond("in_progress")} className={`${btnGhost} px-3 py-1`} data-testid={`admin-complaint-progress-${c.number}`}>Responder</button>
            <button disabled={msg.trim().length < 2} onClick={() => respond("resolved")} className={`${btnPrimary} px-3 py-1`} data-testid={`admin-complaint-resolve-${c.number}`}>Resolver</button>
            <button disabled={msg.trim().length < 2} onClick={() => respond("rejected")} className={`${btnGhost} px-3 py-1 text-red-600`} data-testid={`admin-complaint-reject-${c.number}`}>Rejeitar</button></div></div>}</>}
    </div>
  );
}

export default function AdminComplaints() {
  const [status, setStatus] = useState("open");
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/complaints", { params: { status } }).then(({ data }) => setItems(data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, [status]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="flex flex-col gap-3" data-testid="admin-complaints">
      <select value={status} onChange={(e) => setStatus(e.target.value)} className={`${inputCls} w-auto self-start`} data-testid="admin-complaints-filter"><option value="">Todas</option>{Object.entries(COMPLAINT_STATUS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</select>
      <div className="bo-card divide-y divide-gray-50">{items.map((c) => <Row key={`${c.id}-${c.messages.length}-${c.status}`} c={c} reload={load} />)}{!items.length && <p className="p-4 text-sm text-gray-500">Sem reclamações.</p>}</div>
    </div>
  );
}
